import React, { useState, useEffect, useCallback, useMemo } from "react";
import ReactDataTable from "../../../components/ReactDataTable";
import useTimeSheetApi from "../../../api/timesheet";
import { EmployeeAssignmentDirectoryReportItem } from "../../../model/timesheet";
import { formatAsSevenDigitNumber } from "../../../helper/convertionHealper";

const EmployeeAssignmentDirectoryReportPage: React.FC = () => {
  const [reportList, setReportList] = useState<EmployeeAssignmentDirectoryReportItem[] | null>([]);
  const { fetchEmployeeAssignmentDirectoryReport } = useTimeSheetApi();

  const excelSheetHeader: string[] = [
    "Employee ID",
    "Employee Name",
    "Email",
    "Date of Joining",
    "Designation",
    "Role",
    "Manager Name",
    "Active Project",
  ];

  const columns = [
    {
      name: "Employee ID",
      selector: (row: EmployeeAssignmentDirectoryReportItem) =>
        typeof row.employee_id === "number"
          ? formatAsSevenDigitNumber(row.employee_id)
          : row.employee_id,
      sortable: true,
      width: "120px",
    },
    {
      name: "Employee Name",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.employee_name,
      sortable: true,
      width: "160px",
    },
    {
      name: "Email",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.email,
      sortable: true,
      width: "220px",
    },
    {
      name: "Date of Joining",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.doj,
      sortable: true,
      width: "130px",
    },
    {
      name: "Designation",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.designation,
      sortable: true,
      width: "160px",
    },
    {
      name: "Role",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.role,
      sortable: true,
      width: "120px",
    },
    {
      name: "Manager Name",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.manager_name,
      sortable: true,
      width: "160px",
    },
    {
      name: "Active Project",
      selector: (row: EmployeeAssignmentDirectoryReportItem) => row.active_project,
      sortable: true,
      width: "200px",
    },
  ];

  const getDirectoryReport = useCallback(async () => {
    try {
      const responseData = await fetchEmployeeAssignmentDirectoryReport();
      if (!responseData) return;
      setReportList(responseData);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getDirectoryReport();
  }, [getDirectoryReport]);

  const reportData = useMemo(() => {
    if (!reportList) return [];

    // Sort report list by Employee Name ascending (A to Z)
    const sortedList = [...reportList].sort((a, b) =>
      (a.employee_name || "").localeCompare(b.employee_name || "", undefined, {
        sensitivity: "base",
      })
    );

    return sortedList.map((item) => ({
      ...item,
      employee_id:
        typeof item.employee_id === "number"
          ? formatAsSevenDigitNumber(item.employee_id)
          : item.employee_id,
    }));
  }, [reportList]);

  return (
    <div>
      <ReactDataTable
        columns={columns}
        data={reportData ?? []}
        showFilter={Boolean(reportData && reportData.length > 0)}
        showExport={Boolean(reportData && reportData.length > 0)}
        actionOption={false}
        ReportName={"Employee_Assignment_Directory"}
        searchLabelName="Search by Employee ID or Name"
        excelSheetHeader={excelSheetHeader}
      />
    </div>
  );
};

export default EmployeeAssignmentDirectoryReportPage;
